import { useState } from "react";
import { getStatesForCountry, getLgasForState } from "../utils/phone.js";
import { apiFetch } from "../services/api.js";
import { lsSet, lsGet } from "../utils/storage.js";

export function LocationEditModal({ voter, onClose, onUpdate }) {
  const [state, setState] = useState(voter.state ?? "");
  const [lga, setLga] = useState(voter.lga ?? "");
  const [saving, setSaving] = useState(false);
  const [err, setErr] = useState("");

  const stateList = getStatesForCountry(voter.countryCode);
  const lgaList = state ? getLgasForState(voter.countryCode, state) : [];

  const save = async () => {
    if (!state) { setErr("Please select your state."); return; }
    setSaving(true);
    setErr("");
    const updated = { ...voter, state, lga };
    try {
      // VOTER-6: JWT-based endpoint — works for email-only voters too.
      // The previous /api/voters/:phone call 404'd when voter.phone was null
      // (the URL literally became /api/voters/undefined).
      await apiFetch(`/api/voters/me/location`, {
        method: "PATCH",
        body: JSON.stringify({ state, lga }),
      });
      lsSet("qm_voter", updated);
      onUpdate(updated);
      onClose();
    } catch {
      setErr("Failed to save. Please try again.");
    } finally {
      setSaving(false);
    }
  };

  return (
    <div style={{position:"fixed",inset:0,zIndex:1000,display:"flex",alignItems:"center",justifyContent:"center",background:"rgba(0,0,0,.65)"}} onClick={onClose}>
      <div onClick={e => e.stopPropagation()} style={{width:"100%",maxWidth:380,margin:"0 18px",background:"#0d1724",border:"1px solid #1e2d45",borderRadius:16,padding:24,animation:"fadeUp .25s ease"}}>
        <h3 style={{margin:"0 0 4px",color:"#f1f5f9",fontSize:17,fontWeight:800,fontFamily:"Georgia,serif"}}>Edit Location</h3>
        <p style={{color:"#64748b",fontSize:12,margin:"0 0 20px"}}>Update your state and local government area.</p>

        {/* Country (read-only) */}
        <div style={{marginBottom:14}}>
          <div style={{fontSize:10,fontWeight:700,letterSpacing:"0.1em",color:"#475569",textTransform:"uppercase",marginBottom:6}}>Country</div>
          <div style={{padding:"10px 14px",background:"#090e1a",border:"1px solid #1e2d45",borderRadius:9,color:"#64748b",fontSize:14}}>
            {voter.flag} {voter.country}
          </div>
        </div>

        {/* State */}
        <div style={{marginBottom:14}}>
          <div style={{fontSize:10,fontWeight:700,letterSpacing:"0.1em",color:"#64748b",textTransform:"uppercase",marginBottom:6}}>{voter.stateLabel || "State"}</div>
          <div style={{position:"relative"}}>
            <select className="qm-sel" value={state} onChange={e => { setState(e.target.value); setLga(""); setErr(""); }}>
              <option value="">Select {voter.stateLabel || "State"}...</option>
              {stateList.map(s => <option key={s} value={s}>{s}</option>)}
            </select>
            <span style={{position:"absolute",right:13,top:"50%",transform:"translateY(-50%)",color:"#475569",pointerEvents:"none",fontSize:11}}>▾</span>
          </div>
        </div>

        {/* LGA */}
        {state && lgaList.length > 0 && (
          <div style={{marginBottom:14,animation:"fadeUp .2s ease"}}>
            <div style={{fontSize:10,fontWeight:700,letterSpacing:"0.1em",color:"#64748b",textTransform:"uppercase",marginBottom:6}}>{voter.lgaLabel || "LGA"}</div>
            <div style={{position:"relative"}}>
              <select className="qm-sel" value={lga} onChange={e => { setLga(e.target.value); setErr(""); }}>
                <option value="">Select {voter.lgaLabel || "LGA"}...</option>
                {lgaList.map(l => <option key={l} value={l}>{l}</option>)}
              </select>
              <span style={{position:"absolute",right:13,top:"50%",transform:"translateY(-50%)",color:"#475569",pointerEvents:"none",fontSize:11}}>▾</span>
            </div>
          </div>
        )}

        {err && <div style={{color:"#ef4444",fontSize:12,marginBottom:12}}>{err}</div>}

        <div style={{display:"flex",gap:10}}>
          <button onClick={onClose} style={{flex:1,padding:"11px",background:"#090e1a",border:"1px solid #1e2d45",borderRadius:10,color:"#64748b",fontSize:13,cursor:"pointer",fontFamily:"inherit",fontWeight:600}}>Cancel</button>
          <button onClick={save} disabled={saving} style={{flex:2,padding:"11px",background:"linear-gradient(135deg,#3b82f6,#2563eb)",border:"none",borderRadius:10,color:"#fff",fontSize:13,cursor:saving?"not-allowed":"pointer",fontFamily:"inherit",fontWeight:700,opacity:saving?.6:1}}>
            {saving ? "Saving…" : "Save Location"}
          </button>
        </div>
      </div>
    </div>
  );
}

export default LocationEditModal;
